import { useEffect, useState } from "react";
import { useParams } from "react-router-dom";

import "../styles/App.css";

import accomodationFactory from "../factories/AccomodationFactory";

import Navbar from "../components/Navbar/Navbar";
import Footer from "../components/Footer/Footer";
import DetailBox from "../components/DetailBox/DetailBox";
import AccomodationHeader from "../components/AccommodationHeader/AccommodationHeader";

import Error from "./Error";

function Accomodation() {
  document.title = "Kasa - Logement";

  const [error, setError] = useState(null);
  const [isLoaded, setIsLoaded] = useState(false);
  const [accomodation, setAccomodation] = useState([]);
  const [pictures, setPictures] = useState([]);
  const [carouselLength, setCarouselLength] = useState(0);
  const [equipments, setEquipments] = useState([]);
  const [tags, setTags] = useState([]);

  const params = useParams();

  useEffect(() => {
    fetch("../data/accomodations.json", {
      headers: {
        "Content-Type": "application/json",
        Accept: "application/json",
      },
    })
      .then((response) => {
        return response.json();
      })
      .then(
        (data) => {
          setIsLoaded(true);
          console.log(params);
          const myData = data.find((accomodation) => {
            if (params.id === accomodation.id) {
              return accomodation;
            }
          });
          if (!myData) {
            setError("error");
          }
          const accomodationData = new accomodationFactory(myData, "json");
          setAccomodation(accomodationData);
          setPictures(accomodationData.pictures);
          setCarouselLength(accomodationData.pictures.length);
          setEquipments(accomodationData.equipments);
          setTags(accomodationData.tags);
        },

        (error) => {
          setIsLoaded(true);
          setError(error);
          console.log(error);
        }
      );
  }, []);

  if (error) {
    return <Error />;
  } else if (!isLoaded) {
    return <div>Loading...</div>;
  } else {
    return (
      <div className="Accomodation">
        <Navbar />

        <main>
          <AccomodationHeader
            title={accomodation._title}
            location={accomodation._location}
            pictures={pictures}
            tags={tags}
            hostName={accomodation.hostName}
            hostPicture={accomodation.hostPicture}
            rating={accomodation._rating}
            carouselLength={carouselLength}
          />

          <section className="section--description" id="section--description">
            <div className="container container--description">
              <DetailBox
                title="Description"
                content={accomodation._description}
              />

              <DetailBox
                title="Equipments"
                content={equipments.map((equip) => {
                  return <li key={equip}>{equip}</li>;
                })}
              />
            </div>
          </section>
        </main>

        <Footer />
      </div>
    );
  }
}

export default Accomodation;
